import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.reduce.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between border-b border-slate-200 px-6 py-4"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "min-h-0 flex-1 overflow-y-auto p-6"
};
const _hoisted_4 = {
  class: "mb-5 grid grid-cols-1 gap-4 md:grid-cols-3"
};
const _hoisted_5 = {
  key: 0,
  class: "block"
};
const _hoisted_6 = ["value"];
const _hoisted_7 = {
  key: 1,
  class: "block"
};
const _hoisted_8 = ["value"];
const _hoisted_9 = {
  key: 2,
  class: "block"
};
const _hoisted_10 = ["value"];
const _hoisted_11 = {
  key: 3,
  class: "block"
};
const _hoisted_12 = {
  key: 4,
  class: "block"
};
const _hoisted_13 = {
  key: 5,
  class: "block"
};
const _hoisted_14 = {
  class: "form-label"
};
const _hoisted_15 = {
  key: 6,
  class: "block"
};
const _hoisted_16 = ["value"];
const _hoisted_17 = {
  key: 7,
  class: "block"
};
const _hoisted_18 = {
  key: 8,
  class: "block"
};
const _hoisted_19 = {
  class: "form-label"
};
const _hoisted_20 = {
  key: 9,
  class: "block"
};
const _hoisted_21 = {
  key: 2,
  class: "mb-5 rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800"
};
const _hoisted_22 = {
  key: 3,
  class: "mb-5 grid grid-cols-1 gap-3 rounded-lg border border-slate-200 bg-slate-50 p-4 text-sm md:grid-cols-4"
};
const _hoisted_23 = {
  class: "font-mono text-slate-900"
};
const _hoisted_24 = {
  class: "font-medium text-slate-900"
};
const _hoisted_25 = {
  class: "text-slate-900"
};
const _hoisted_26 = {
  class: "text-slate-900"
};
const _hoisted_27 = {
  class: "grid grid-cols-1 gap-4 md:grid-cols-2"
};
const _hoisted_28 = {
  class: "md:col-span-2 rounded-lg border border-slate-200 bg-slate-50/60 p-4"
};
const _hoisted_29 = {
  class: "flex flex-wrap items-start justify-between gap-3"
};
const _hoisted_30 = {
  class: "form-label"
};
const _hoisted_31 = {
  class: "mt-0.5 text-xs text-slate-500"
};
const _hoisted_32 = {
  key: 0
};
const _hoisted_33 = ["accept"];
const _hoisted_34 = {
  key: 0,
  class: "mt-3 space-y-2"
};
const _hoisted_35 = {
  class: "grid grid-cols-1 gap-3 md:grid-cols-[1fr_220px]"
};
const _hoisted_36 = {
  class: "block"
};
const _hoisted_37 = {
  class: "rounded-md bg-white px-3 py-2 text-xs text-slate-500"
};
const _hoisted_38 = {
  class: "space-y-2"
};
const _hoisted_39 = {
  class: "min-w-0"
};
const _hoisted_40 = {
  class: "truncate text-sm font-medium text-slate-900"
};
const _hoisted_41 = {
  class: "text-xs text-slate-500"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = {
  key: 1,
  class: "mt-3 rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-700"
};
const _hoisted_44 = {
  key: 2,
  class: "mt-3 rounded-md border border-dashed border-slate-300 bg-white px-4 py-6 text-center text-sm text-slate-500"
};
const _hoisted_45 = {
  class: "block md:col-span-2"
};
const _hoisted_46 = {
  key: 1,
  class: "mx-auto max-w-2xl"
};
const _hoisted_47 = {
  class: "rounded-lg border border-slate-200 bg-slate-50/60 p-6"
};
const _hoisted_48 = {
  key: 0,
  class: "text-center"
};
const _hoisted_49 = {
  class: "text-sm text-slate-500"
};
const _hoisted_50 = {
  class: "shrink-0 text-slate-500"
};
const _hoisted_51 = {
  class: "min-w-0 break-all text-right font-medium text-slate-900"
};
const _hoisted_52 = {
  key: 2,
  class: "mx-auto flex max-w-md flex-col items-center py-10 text-center"
};
const _hoisted_53 = {
  class: "mt-4 text-lg font-semibold text-slate-900"
};
const _hoisted_54 = {
  key: 0,
  class: "mt-2 text-sm font-medium text-slate-700"
};
const _hoisted_55 = {
  class: "flex justify-end gap-3 border-t border-slate-200 px-6 py-4"
};
const _hoisted_56 = ["disabled"];
const _hoisted_57 = ["disabled"];
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';
import { createUploadSession, confirmUploadSession, cancelUploadSession, getFolderTree } from '@/api/assets';
import { submitWealthDecreaseApply, submitWealthIncreaseApply, submitWealthInvestApply, submitWealthRolloverApply, submitWealthWithdrawApply } from '@/api/wealth';
import WealthBatchSelector from './WealthBatchSelector.vue';
import AppModal from '@/components/AppModal.vue';
import { cleanPayload, formatDate, formatMoney, getBadgeMeta, toNumber } from '../utils';
const CONTRACT_ATTACHMENT_ACCEPT = '.pdf,.doc,.docx,image/*';
export default {
  __name: 'WealthOperationApplyModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    operationType: {
      type: String,
      default: 'INVEST'
    },
    preset: {
      type: Object,
      default: () => ({})
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'submitted'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const CONTRACT_ATTACHMENT_EXTENSIONS = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
    const form = reactive(defaultForm());
    const step = ref('edit');
    const decreaseItems = ref([]);
    const selectedBatch = ref(null);
    const fileInput = ref(null);
    const pendingAttachmentFiles = ref([]);
    const uploadedAttachmentAssetIds = ref([]);
    const folderLoading = ref(false);
    const assetFolderOptions = ref([]);
    const uploadingAttachments = ref(false);
    const localSubmitting = ref(false);
    const currentUploadSessionId = ref(null);
    const operationLabel = computed(() => getBadgeMeta('operation', props.operationType).label);
    const needsContract = computed(() => ['INCREASE', 'DECREASE', 'WITHDRAW'].includes(props.operationType));
    const attachmentLabel = computed(() => props.operationType === 'INVEST' ? '合同文件' : '申请附件');
    const isSubmitting = computed(() => props.submitting || uploadingAttachments.value || localSubmitting.value);
    const fileAccept = computed(() => props.operationType === 'INVEST' ? CONTRACT_ATTACHMENT_ACCEPT : undefined);
    const contractDisplayName = computed(() => {
      if (!form.contractId) return '请从客户合同发起申请';
      return form.contractName || form.contractNo || `合同 ${form.contractId}`;
    });
    const rolloverBatchDisplayName = computed(() => {
      if (selectedBatch.value?.batchNo) return selectedBatch.value.batchNo;
      return form.batchNo || '请从合同批次发起续期';
    });
    const decreaseTotalAmount = computed(() => decreaseItems.value.reduce((sum, item) => sum + toNumber(item.amount), 0));
    const isMoneyOut = computed(() => ['DECREASE', 'WITHDRAW'].includes(props.operationType));
    const confirmAmountText = computed(() => {
      if (['INVEST', 'INCREASE'].includes(props.operationType)) return form.amount ? `¥${formatMoney(form.amount)}` : null;
      if (props.operationType === 'DECREASE') return `¥${formatMoney(decreaseTotalAmount.value)}`;
      if (props.operationType === 'ROLLOVER' && selectedBatch.value) return `¥${formatMoney(selectedBatch.value.remainingPrincipalAmount)}`;
      return null;
    });
    const confirmRows = computed(() => {
      const rows = [];
      if (props.operationType === 'INVEST') {
        rows.push({
          label: '客户名称',
          value: form.customerName || '—'
        });
        rows.push({
          label: '合同名称',
          value: form.contractName
        });
        if (form.contractNo?.trim()) rows.push({
          label: '合同编号',
          value: form.contractNo.trim()
        });
      }
      if (needsContract.value) rows.push({
        label: '合同',
        value: contractDisplayName.value
      });
      if (props.operationType === 'ROLLOVER') rows.push({
        label: '原批次',
        value: rolloverBatchDisplayName.value
      });
      if (props.operationType === 'WITHDRAW') rows.push({
        label: '退出金额',
        value: '按合同剩余本金全额退出，以审批通过时实时余额为准'
      });
      if (props.operationType === 'DECREASE') rows.push({
        label: '减资批次',
        value: `${decreaseItems.value.length} 个批次`
      });
      if (['INVEST', 'INCREASE', 'ROLLOVER'].includes(props.operationType)) {
        rows.push({
          label: '年利率',
          value: `${form.annualRate}%`
        });
        rows.push({
          label: props.operationType === 'INVEST' ? '注资日期' : '起息日',
          value: form.valueDate
        });
        rows.push({
          label: '到期日',
          value: form.maturityDate
        });
      }
      const attachmentCount = pendingAttachmentFiles.value.length + uploadedAttachmentAssetIds.value.length;
      rows.push({
        label: '附件',
        value: attachmentCount ? `${attachmentCount} 个文件` : '无'
      });
      if (form.description?.trim()) rows.push({
        label: '说明',
        value: form.description.trim()
      });
      return rows;
    });
    const doneSummary = computed(() => {
      const parts = [];
      if (form.customerName) parts.push(form.customerName);
      if (needsContract.value) parts.push(contractDisplayName.value);else if (props.operationType === 'INVEST') parts.push(form.contractName);
      if (confirmAmountText.value) parts.push(confirmAmountText.value);
      return parts.filter(Boolean).join(' · ');
    });
    function defaultForm() {
      return {
        wealthCustomerId: null,
        customerName: '',
        contractId: null,
        batchId: null,
        batchNo: '',
        contractNo: '',
        contractName: '',
        amount: null,
        annualRate: null,
        valueDate: '',
        maturityDate: '',
        description: '',
        assetFolderId: null
      };
    }
    function reset() {
      Object.assign(form, defaultForm(), props.preset || {});
      step.value = 'edit';
      decreaseItems.value = [];
      selectedBatch.value = null;
      pendingAttachmentFiles.value = [];
      uploadedAttachmentAssetIds.value = [];
      if (fileInput.value) fileInput.value.value = '';
      if (props.operationType === 'INVEST') {
        ensureAssetFoldersLoaded();
      }
    }
    function close() {
      emit('update:modelValue', false);
    }
    async function commonPayload() {
      return {
        description: form.description?.trim(),
        attachmentAssetIds: await uploadPendingAttachmentFiles()
      };
    }
    function validateCommonDates() {
      if (!form.annualRate || !form.valueDate || !form.maturityDate) {
        ElMessage.warning(`请填写年利率、${props.operationType === 'INVEST' ? '注资日期' : '起息日'}和到期日`);
        return false;
      }
      if (form.valueDate >= form.maturityDate) {
        ElMessage.warning('起息日必须早于到期日');
        return false;
      }
      return true;
    }
    function validateInvestForm() {
      if (!form.wealthCustomerId) {
        ElMessage.warning('请从客户详情发起注资');
        return false;
      }
      if (!form.contractName?.trim()) {
        ElMessage.warning('请填写合同名称');
        return false;
      }
      if (!form.amount || toNumber(form.amount) <= 0) {
        ElMessage.warning('请填写注资金额');
        return false;
      }
      return validateCommonDates();
    }
    function validateForm() {
      if (props.operationType === 'INVEST') return validateInvestForm();
      if (props.operationType === 'INCREASE') {
        if (!form.contractId || !form.amount) {
          ElMessage.warning('请选择合同并填写增资金额');
          return false;
        }
        return validateCommonDates();
      }
      if (props.operationType === 'DECREASE') {
        if (!form.contractId || decreaseTotalAmount.value <= 0 || !decreaseItems.value.length) {
          ElMessage.warning('请选择合同和减资批次');
          return false;
        }
        return true;
      }
      if (props.operationType === 'WITHDRAW') {
        if (!form.contractId) {
          ElMessage.warning('请选择合同');
          return false;
        }
        return true;
      }
      if (props.operationType === 'ROLLOVER') {
        if (!form.batchId) {
          ElMessage.warning('请选择续期批次');
          return false;
        }
        return validateCommonDates();
      }
      return true;
    }
    function goConfirm() {
      if (isSubmitting.value) return;
      if (!validateForm()) return;
      step.value = 'confirm';
    }
    async function submit() {
      if (isSubmitting.value) return;
      localSubmitting.value = true;
      try {
        if (props.operationType === 'INVEST') {
          await submitWealthInvestApply(cleanPayload({
            wealthCustomerId: form.wealthCustomerId,
            contractNo: form.contractNo?.trim(),
            contractName: form.contractName?.trim(),
            signDate: form.valueDate,
            amount: form.amount,
            annualRate: form.annualRate,
            valueDate: form.valueDate,
            maturityDate: form.maturityDate,
            ...(await commonPayload())
          }));
        } else if (props.operationType === 'INCREASE') {
          await submitWealthIncreaseApply(form.contractId, cleanPayload({
            contractId: form.contractId,
            amount: form.amount,
            annualRate: form.annualRate,
            valueDate: form.valueDate,
            maturityDate: form.maturityDate,
            ...(await commonPayload())
          }));
        } else if (props.operationType === 'DECREASE') {
          await submitWealthDecreaseApply(form.contractId, cleanPayload({
            contractId: form.contractId,
            amount: decreaseTotalAmount.value,
            batchItems: decreaseItems.value,
            ...(await commonPayload())
          }));
        } else if (props.operationType === 'WITHDRAW') {
          await submitWealthWithdrawApply(form.contractId, cleanPayload({
            contractId: form.contractId,
            ...(await commonPayload())
          }));
        } else if (props.operationType === 'ROLLOVER') {
          await submitWealthRolloverApply(form.batchId, cleanPayload({
            batchId: form.batchId,
            annualRate: form.annualRate,
            valueDate: form.valueDate,
            maturityDate: form.maturityDate,
            ...(await commonPayload())
          }));
        }
        step.value = 'done';
        emit('submitted');
      } finally {
        localSubmitting.value = false;
      }
    }
    function triggerFileInput() {
      fileInput.value?.click();
    }
    function handleFileSelect(event) {
      const files = Array.from(event.target.files || []);
      if (files.length) {
        const acceptedFiles = files.filter(isAllowedAttachmentFile);
        if (acceptedFiles.length) {
          pendingAttachmentFiles.value = [...pendingAttachmentFiles.value, ...acceptedFiles];
          ensureAssetFoldersLoaded();
        }
      }
      event.target.value = '';
    }
    function isAllowedAttachmentFile(file) {
      if (props.operationType !== 'INVEST') return true;
      return isAllowedContractAttachmentFile(file);
    }
    function isAllowedContractAttachmentFile(file) {
      const extension = file.name.includes('.') ? file.name.split('.').pop().toLowerCase() : '';
      const allowed = file.type?.startsWith('image/') || CONTRACT_ATTACHMENT_EXTENSIONS.includes(extension);
      if (!allowed) {
        ElMessage.warning('合同文件仅支持 PDF、Word 文档或图片');
      }
      return allowed;
    }
    function removeAttachmentFile(index) {
      pendingAttachmentFiles.value.splice(index, 1);
    }
    function formatFileSize(bytes) {
      if (!bytes) return '0 B';
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
      return `${(bytes / 1048576).toFixed(1)} MB`;
    }
    function getAssetType(file) {
      if (file.type?.startsWith('image/')) return 'IMAGE';
      if (file.type?.startsWith('video/')) return 'VIDEO';
      return 'FILE';
    }
    function assetNameOf(file) {
      const dotIndex = file.name.lastIndexOf('.');
      return dotIndex > 0 ? file.name.slice(0, dotIndex) : file.name;
    }
    async function ensureAssetFoldersLoaded() {
      if (assetFolderOptions.value.length || folderLoading.value) return;
      folderLoading.value = true;
      try {
        const tree = await getFolderTree();
        assetFolderOptions.value = flattenManageableFolders(tree || []);
        if (!form.assetFolderId && assetFolderOptions.value.length) {
          form.assetFolderId = assetFolderOptions.value[0].id;
        }
      } catch {
        // request interceptor handles visible error
      } finally {
        folderLoading.value = false;
      }
    }
    function flattenManageableFolders(nodes, parentPath = '') {
      return nodes.flatMap(node => {
        const path = parentPath ? `${parentPath} / ${node.name}` : node.name;
        const current = node.permissionLevel === 'MANAGE' && !node.pathOnly ? [{
          id: node.id,
          path
        }] : [];
        return [...current, ...flattenManageableFolders(node.children || [], path)];
      });
    }
    async function uploadPendingAttachmentFiles() {
      if (!pendingAttachmentFiles.value.length) return uploadedAttachmentAssetIds.value;
      if (!form.assetFolderId) {
        ElMessage.warning('请选择合同文件存放文件夹');
        throw new Error('asset folder required');
      }
      uploadingAttachments.value = true;
      try {
        const assetIds = [];
        for (const file of pendingAttachmentFiles.value) {
          assetIds.push(await uploadOneAttachmentFile(file));
        }
        uploadedAttachmentAssetIds.value = [...uploadedAttachmentAssetIds.value, ...assetIds];
        pendingAttachmentFiles.value = [];
        if (fileInput.value) fileInput.value.value = '';
        return uploadedAttachmentAssetIds.value;
      } finally {
        uploadingAttachments.value = false;
      }
    }
    async function uploadOneAttachmentFile(file) {
      if (!isAllowedAttachmentFile(file)) {
        throw new Error('unsupported attachment file type');
      }
      try {
        const credential = await createUploadSession({
          folderId: form.assetFolderId,
          assetType: getAssetType(file),
          originalName: file.name,
          mimeType: file.type || 'application/octet-stream',
          fileSize: file.size
        });
        currentUploadSessionId.value = credential.sessionId;
        await axios.put(credential.uploadUrl, file, {
          headers: {
            'Content-Type': file.type || 'application/octet-stream',
            ...(credential.headers || {})
          }
        });
        const asset = await confirmUploadSession(credential.sessionId, {
          uploadToken: credential.uploadToken,
          name: assetNameOf(file),
          description: props.operationType === 'INVEST' ? '财富合同文件' : '财富申请附件',
          tagIds: []
        });
        currentUploadSessionId.value = null;
        return asset.id;
      } catch (error) {
        await cancelPendingUploadSession();
        throw error;
      }
    }
    async function cancelPendingUploadSession() {
      if (!currentUploadSessionId.value) return;
      const sessionId = currentUploadSessionId.value;
      currentUploadSessionId.value = null;
      try {
        await cancelUploadSession(sessionId);
      } catch {
        // 上传会话取消失败不覆盖原始提交错误
      }
    }
    watch(() => props.modelValue, value => {
      if (value) reset();
    });
    watch(() => props.operationType, reset);
    watch(() => props.preset, reset, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.modelValue,
        size: "5xl",
        "z-index": 70,
        onClose: close
      }, {
        default: _withCtx(() => [_createElementVNode("header", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, "提交" + _toDisplayString(operationLabel.value) + "申请", 1), _cache[12] || (_cache[12] = _createElementVNode("p", {
          class: "mt-1 text-sm text-slate-500"
        }, "申请提交后进入审批，审批通过后才落账。", -1))]), _createElementVNode("button", {
          type: "button",
          class: "rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
          onClick: close
        }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
          class: "h-5 w-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("main", _hoisted_3, [step.value === 'edit' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_4, [__props.operationType === 'INVEST' ? (_openBlock(), _createElementBlock("label", _hoisted_5, [_cache[14] || (_cache[14] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("客户名称 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createElementVNode("input", {
          value: form.customerName || '请从客户详情发起注资',
          readonly: "",
          class: "form-readonly w-full"
        }, null, 8, _hoisted_6)])) : _createCommentVNode("", true), needsContract.value ? (_openBlock(), _createElementBlock("label", _hoisted_7, [_cache[15] || (_cache[15] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("合同名称 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createElementVNode("input", {
          value: contractDisplayName.value,
          readonly: "",
          class: "form-readonly w-full"
        }, null, 8, _hoisted_8)])) : _createCommentVNode("", true), __props.operationType === 'ROLLOVER' ? (_openBlock(), _createElementBlock("label", _hoisted_9, [_cache[16] || (_cache[16] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("原批次 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createElementVNode("input", {
          value: rolloverBatchDisplayName.value,
          readonly: "",
          class: "form-readonly w-full"
        }, null, 8, _hoisted_10)])) : _createCommentVNode("", true), __props.operationType === 'INVEST' ? (_openBlock(), _createElementBlock("label", _hoisted_11, [_cache[17] || (_cache[17] = _createElementVNode("span", {
          class: "form-label"
        }, "合同编号", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.contractNo = $event),
          class: "form-input w-full",
          placeholder: "可不填，由后端编号规则处理"
        }, null, 512), [[_vModelText, form.contractNo]])])) : _createCommentVNode("", true), __props.operationType === 'INVEST' ? (_openBlock(), _createElementBlock("label", _hoisted_12, [_cache[18] || (_cache[18] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("合同名称 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.contractName = $event),
          class: "form-input w-full",
          placeholder: "请输入合同名称"
        }, null, 512), [[_vModelText, form.contractName]])])) : _createCommentVNode("", true), ['INVEST', 'INCREASE'].includes(__props.operationType) ? (_openBlock(), _createElementBlock("label", _hoisted_13, [_createElementVNode("span", _hoisted_14, [_createTextVNode(_toDisplayString(operationLabel.value) + "金额 ", 1), _cache[19] || (_cache[19] = _createElementVNode("span", {
          class: "text-red-500"
        }, "*", -1))]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.amount = $event),
          type: "number",
          min: "0",
          step: "0.01",
          class: "form-input w-full"
        }, null, 512), [[_vModelText, form.amount, void 0, {
          number: true
        }]])])) : _createCommentVNode("", true), __props.operationType === 'DECREASE' ? (_openBlock(), _createElementBlock("label", _hoisted_15, [_cache[20] || (_cache[20] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("减资金额 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createElementVNode("input", {
          value: `¥${_unref(formatMoney)(decreaseTotalAmount.value)}`,
          readonly: "",
          class: "form-readonly w-full"
        }, null, 8, _hoisted_16)])) : _createCommentVNode("", true), ['INVEST', 'INCREASE', 'ROLLOVER'].includes(__props.operationType) ? (_openBlock(), _createElementBlock("label", _hoisted_17, [_cache[21] || (_cache[21] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("年利率（%） "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.annualRate = $event),
          type: "number",
          min: "0",
          step: "0.0001",
          class: "form-input w-full",
          placeholder: "例如：3.65 表示 3.65%"
        }, null, 512), [[_vModelText, form.annualRate, void 0, {
          number: true
        }]])])) : _createCommentVNode("", true), ['INVEST', 'INCREASE', 'ROLLOVER'].includes(__props.operationType) ? (_openBlock(), _createElementBlock("label", _hoisted_18, [_createElementVNode("span", _hoisted_19, [_createTextVNode(_toDisplayString(__props.operationType === 'INVEST' ? '注资日期' : '起息日') + " ", 1), _cache[22] || (_cache[22] = _createElementVNode("span", {
          class: "text-red-500"
        }, "*", -1))]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.valueDate = $event),
          type: "date",
          class: "form-input w-full"
        }, null, 512), [[_vModelText, form.valueDate]])])) : _createCommentVNode("", true), ['INVEST', 'INCREASE', 'ROLLOVER'].includes(__props.operationType) ? (_openBlock(), _createElementBlock("label", _hoisted_20, [_cache[23] || (_cache[23] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("到期日 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.maturityDate = $event),
          type: "date",
          class: "form-input w-full"
        }, null, 512), [[_vModelText, form.maturityDate]])])) : _createCommentVNode("", true)]), __props.operationType === 'DECREASE' ? (_openBlock(), _createBlock(WealthBatchSelector, {
          key: 0,
          modelValue: decreaseItems.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => decreaseItems.value = $event),
          "contract-id": form.contractId,
          mode: "decrease",
          class: "mb-5"
        }, null, 8, ["modelValue", "contract-id"])) : _createCommentVNode("", true), __props.operationType === 'ROLLOVER' && form.contractId ? (_openBlock(), _createBlock(WealthBatchSelector, {
          key: 1,
          "contract-id": form.contractId,
          "selected-batch-id": form.batchId,
          mode: "rollover",
          class: "mb-5",
          "onUpdate:selectedBatchId": _cache[7] || (_cache[7] = $event => form.batchId = $event),
          onSelectRow: _cache[8] || (_cache[8] = $event => selectedBatch.value = $event)
        }, null, 8, ["contract-id", "selected-batch-id"])) : _createCommentVNode("", true), __props.operationType === 'WITHDRAW' ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 撤资申请不传金额，后端按提交时合同剩余本金生成申请快照，落账时再次按实时批次余额计算实际退出金额。 ")) : _createCommentVNode("", true), __props.operationType === 'ROLLOVER' && selectedBatch.value ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", null, [_cache[24] || (_cache[24] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "原批次", -1)), _createElementVNode("div", _hoisted_23, _toDisplayString(selectedBatch.value.batchNo), 1)]), _createElementVNode("div", null, [_cache[25] || (_cache[25] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "剩余本金", -1)), _createElementVNode("div", _hoisted_24, "¥" + _toDisplayString(_unref(formatMoney)(selectedBatch.value.remainingPrincipalAmount)), 1)]), _createElementVNode("div", null, [_cache[26] || (_cache[26] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "原起息日", -1)), _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(formatDate)(selectedBatch.value.valueDate)), 1)]), _createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "原到期日", -1)), _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(formatDate)(selectedBatch.value.maturityDate)), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [_createElementVNode("section", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_30, _toDisplayString(attachmentLabel.value), 1), _createElementVNode("p", _hoisted_31, [_cache[28] || (_cache[28] = _createTextVNode(" 选择本地文件，提交申请时自动上传并关联到本次申请。 ", -1)), props.operationType === 'INVEST' ? (_openBlock(), _createElementBlock("span", _hoisted_32, "合同文件仅支持 PDF、Word 文档或图片。")) : _createCommentVNode("", true)])]), _createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: triggerFileInput
        }, "选择文件")]), _createElementVNode("input", {
          ref_key: "fileInput",
          ref: fileInput,
          type: "file",
          multiple: "",
          class: "hidden",
          accept: fileAccept.value,
          onChange: handleFileSelect
        }, null, 40, _hoisted_33), pendingAttachmentFiles.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("label", _hoisted_36, [_cache[29] || (_cache[29] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("存放素材文件夹 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_select, {
          modelValue: form.assetFolderId,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.assetFolderId = $event),
          class: "form-select w-full",
          disabled: folderLoading.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: folderLoading.value ? '正在加载文件夹...' : '请选择文件夹',
            value: null
          }, null, 8, ["label"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assetFolderOptions.value, folder => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: folder.id,
              label: folder.path,
              value: folder.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "disabled"])]), _createElementVNode("div", _hoisted_37, " 已选择 " + _toDisplayString(pendingAttachmentFiles.value.length) + " 个文件，提交时上传。 ", 1)]), _createElementVNode("div", _hoisted_38, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingAttachmentFiles.value, (file, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: `${file.name}-${file.size}-${index}`,
            class: "flex items-center justify-between gap-3 rounded-md border border-slate-200 bg-white px-3 py-2"
          }, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString(file.name), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(formatFileSize(file.size)), 1)]), _createElementVNode("button", {
            type: "button",
            class: "text-sm text-red-600 hover:text-red-700",
            onClick: $event => removeAttachmentFile(index)
          }, "移除", 8, _hoisted_42)]);
        }), 128))])])) : _createCommentVNode("", true), uploadedAttachmentAssetIds.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_43, " 已上传 " + _toDisplayString(uploadedAttachmentAssetIds.value.length) + " 个文件，提交失败后重试会继续携带这些文件。 ", 1)) : _createCommentVNode("", true), !pendingAttachmentFiles.value.length && !uploadedAttachmentAssetIds.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_44, " 暂未选择文件 ")) : _createCommentVNode("", true)]), _createElementVNode("label", _hoisted_45, [_cache[30] || (_cache[30] = _createElementVNode("span", {
          class: "form-label"
        }, "说明", -1)), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.description = $event),
          rows: "3",
          class: "form-textarea w-full",
          placeholder: "请输入申请说明"
        }, null, 512), [[_vModelText, form.description]])])])], 64)) : step.value === 'confirm' ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [confirmAmountText.value ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, _toDisplayString(operationLabel.value) + "金额", 1), _createElementVNode("div", {
          class: _normalizeClass(["mt-1 text-3xl money-text", isMoneyOut.value ? 'text-red-600' : 'text-slate-900'])
        }, _toDisplayString(confirmAmountText.value), 3)])) : _createCommentVNode("", true), _createElementVNode("dl", {
          class: _normalizeClass(["space-y-3", confirmAmountText.value ? 'mt-6 border-t border-slate-200 pt-5' : ''])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confirmRows.value, row => {
          return _openBlock(), _createElementBlock("div", {
            key: row.label,
            class: "flex items-start justify-between gap-6 text-sm"
          }, [_createElementVNode("dt", _hoisted_50, _toDisplayString(row.label), 1), _createElementVNode("dd", _hoisted_51, _toDisplayString(row.value), 1)]);
        }), 128))], 2)]), _cache[31] || (_cache[31] = _createElementVNode("div", {
          class: "mt-4 rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800"
        }, " 提交后进入审批流程，审批通过后才落账。请核对以上信息无误后再确认提交。 ", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_52, [_cache[32] || (_cache[32] = _createElementVNode("div", {
          class: "flex h-14 w-14 items-center justify-center rounded-full bg-emerald-100"
        }, [_createElementVNode("svg", {
          class: "h-7 w-7 text-emerald-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 13l4 4L19 7"
        })])], -1)), _createElementVNode("h4", _hoisted_53, _toDisplayString(operationLabel.value) + "申请已提交", 1), doneSummary.value ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(doneSummary.value), 1)) : _createCommentVNode("", true), _cache[33] || (_cache[33] = _createElementVNode("p", {
          class: "mt-1 text-sm text-slate-500"
        }, "可在「资金申请」列表跟踪审批进度。", -1))]))]), _createElementVNode("footer", _hoisted_55, [step.value === 'edit' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: close
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: goConfirm
        }, "核对并提交")], 64)) : step.value === 'confirm' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          disabled: isSubmitting.value,
          onClick: _cache[11] || (_cache[11] = $event => step.value = 'edit')
        }, "返回修改", 8, _hoisted_56), _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(isMoneyOut.value ? 'btn-danger-secondary' : 'btn-primary'),
          disabled: isSubmitting.value,
          onClick: submit
        }, _toDisplayString(uploadingAttachments.value ? '正在上传文件...' : localSubmitting.value ? '正在提交...' : '确认提交'), 11, _hoisted_57)], 64)) : (_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          class: "btn-primary",
          onClick: close
        }, "关闭"))])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};